<template>
  <div>
    <v-card>
      <v-card-title class="headline primary white--text" dark primary-title>
        {{ $t('modal.deactivate') }}
      </v-card-title>

      <v-card-text class="body-1">
        <p class="pt-4">{{ $tc('form.deactivateAll', 1, { count: 1 }) }}</p>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn @click="$emit('close')">
          {{ $t('button.cancel') }}
        </v-btn>
        <v-btn color="primary" @click="doDeactivate">
          {{ $t('button.deactivate') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  computed: {},
  methods: {
    doDeactivate() {
      this.$emit('deactivate');
    },
  },
};
</script>
